import { ApiResponse } from '../../core/api/api.models';

/** Kpi id requested from `Report/GetKpiCards` for the sidebar's Appointments nav badge —
 * matches the `id: "appt_today"` card the live endpoint returns (same card the
 * appointments page's own "Today" stat tile reads via APPOINTMENT_KPI_IDS). */
export const TODAYS_APPOINTMENTS_KPI_ID = 'appt_today';

/** `appt_today` only exists under the backend's "appointments" module card set
 * (`ModuleCardMap`) — the default module is "dashboard", which doesn't include it. */
export const APPOINTMENTS_KPI_MODULE = 'appointments';

export interface KpiCardDto {
  id: string;
  value: number;
}

export type GetKpiCardsResponse = ApiResponse<KpiCardDto[]>;

/** Reads the `appt_today` card's value out of the KPI response; 0 when the envelope
 * failed, the card is missing, or the payload didn't send a number. */
export function extractTodaysAppointmentCount(response: GetKpiCardsResponse | null): number {
  if (!response?.Success || !Array.isArray(response.Data)) return 0;

  const card = response.Data.find((d) => d.id === TODAYS_APPOINTMENTS_KPI_ID);
  return typeof card?.value === 'number' ? card.value : 0;
}
